import React from "react";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";

import { Button, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import IntlTextField from "components/form/IntlTextField";

function ImageMetas({ file, onChange, children }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={async (values) => {
            await onChange(values);
            close();
          }}
          initialValues={file ? file.metas : {}}
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} autoComplete="off">
              <Dialog.Title color="primary">Modifier une image</Dialog.Title>

              <Dialog.Content>
                <Stack spacing={2}>
                  <IntlTextField name="alt" label="Texte alternatif" />
                  <IntlTextField name="legend" label="Légende" />
                </Stack>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Valider
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}

export default ImageMetas;
